import { h } from 'preact';
import Image from '../utils/image';

const GwpMultipleProductItem = ({
  line,
  productTitle,
  image,
  productList,
  productTitle1,
  productTitle2,
  productTitle3,
  productSubtitle,
  lineItemPromoMessage1,
  productBadge,
  mode = 'form', // 'form' or 'line-item',
  selectedProduct,
  setSelectedProduct,
  handleAddItem = () => undefined,
  handleRemoveItem = () => undefined,
}) => {
  const productListWithCustomTitles = productList.map((product, index) => {
    let customTitle = product.title;
    if (index === 0 && productTitle1) {
      customTitle = productTitle1;
    } else if (index === 1 && productTitle2) {
      customTitle = productTitle2;
    } else if (index === 2 && productTitle3) {
      customTitle = productTitle3;
    }
    return { ...product, title: customTitle };
  });

  const id = line?.properties?._gwp_id || line?.id || '';

  return (
    <div
      className={mode === 'form' ? 'px-1.5 lg:px-4 bg-grey-12' : 'border-b border-grey-4 last-of-type:border-0'}
      data-cart-item-gwp
    >
      <div
        className={`flex items-start lg:items-center gap-3 md:gap-4 bg-white rounded
      ${mode === 'form' ? 'p-3 lg:p-4' : 'py-3 lg:py-4'}`}
      >
        {/* product image */}
        {selectedProduct?.featuredImage || image ? (
          <div className="basis-[116px] max-w-[116px] md:basis-[136px] md:max-w-[136px] xs:h-[116px] md:!h-[136px] relative">
            <Image
              src={selectedProduct?.featuredImage || image}
              classes="w-full object-contain rounded-[4px]"
            />
          </div>
        ) : null}

        {/* product details */}
        <div className="flex flex-col justify-between w-full max-w-[223px] md:max-w-[356px]">
          <div className="w-full flex flex-col lg:flex-row justify-center gap-4 mb-3 lg:mb-4">
            <div className="w-full">
              {productTitle || selectedProduct?.title ? (
                <p className="mb-2 text-[16px] text-brown-1 font-normal leading-none">
                  {mode === 'line-item' ? selectedProduct?.title : productTitle}
                </p>
              ) : null}
              {productSubtitle || selectedProduct?.subtitle ? (
                <p className="text-[14px] text-brown-3 font-normal leading-none tracking-[0.14px]">
                  {mode === 'line-item' && selectedProduct?.subtitle ? selectedProduct?.subtitle : productSubtitle}
                </p>
              ) : null}
            </div>
            <p className="text-[16px] text-red font-normal leading-none tracking-[0.16px]">Free</p>
          </div>
          {lineItemPromoMessage1 ? (
            <p className="mb-4 text-[14px] text-orange-1 font-normal leading-none">{lineItemPromoMessage1}</p>
          ) : null}
          {productBadge ? (
            <div className="w-fit h-5 px-1.5 mb-3 lg:mb-5 bg-grey-11 rounded-full flex items-center text-[9px] text-brown-1 font-medium leading-none uppercase">
              {productBadge}
            </div>
          ) : null}
          <div
            className={`flex items-start lg:justify-between gap-5
              ${mode === 'form' ? 'flex-col lg:flex-row' : ''}`}
          >
            <div className="w-full flex flex-wrap items-center gap-4">
              {mode === 'form' &&
                productListWithCustomTitles.length > 1 &&
                productListWithCustomTitles.map((product) => (
                  <label
                    key={product.id}
                    className="inline-flex items-center gap-1.5 cursor-pointer"
                    htmlFor={`product-${product.id}`}
                  >
                    <input
                      name={`gwp-product${id ? `-${id}` : ''}`}
                      type="radio"
                      className="hidden peer"
                      id={`product-${product.id}`}
                      checked={selectedProduct.id === product.id}
                      onChange={() => setSelectedProduct(product)}
                      disabled={mode === 'line-item'}
                    />
                    <div className="relative size-3 rounded-full peer-checked:border peer-checked:border-brown-1 bg-grey-11 before:content-[''] before:absolute before:bg-brown-1 before:w-2 before:h-2 before:rounded-full before:opacity-0 before:transition-opacity before:duration-200 before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 peer-checked:before:opacity-100"></div>
                    <span className="text-brown-1/80 text-[13px] capitalize font-normal leading-none">
                      {product.title}
                    </span>
                  </label>
                ))}
            </div>
            <button
              className="shrink-0 text-[14px] text-brown-1 font-normal leading-none tracking-[0.14px] underline"
              onClick={
                mode === 'form' ? () => handleAddItem(selectedProduct) : () => handleRemoveItem(selectedProduct, line)
              }
            >
              {mode === 'form' ? 'Add to bag' : 'Remove'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GwpMultipleProductItem;
